export default {
  primary: {
    green: "#3BA948",
    darkgreen: "#2F7E38",
    blue: "#272D77",
    lightblue: "#EDF2F7",
  },
  secondary: {
    critical: "#E53E3E",
    blue: "#13174F",
  },
  text: {
    default: "#1A1A1A",
    subtitle: "#69696B",
    white: "#FFFFFF",
    black: "#000000",
    red: "#E53E3E",
  },
  background: {
    white: "#FFFFFF",
    grey: "#F8F8F9",
    darkred: "#CC3333",
    interactive: "#EBF6ED",
  },
  gray: {
    gray300: "#CBD5E0",
    gray600: "#4A5568",
    gray83: "#D4D4D4",
  },
};
